export const endpointBE: string = "http://localhost:8080";
// export const endpointBE: string = "https://666d5c8ba84b4a56799dd7ae75760df6.serveo.net";